import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import reviewsAPI from "../../modules/reviews/api"
import {recordEvent} from "../../modules/app/plugins/metricPlugin";
import Button from "./Button";
import { Tooltip } from 'reactstrap';

/**
 * A Button that cycles through smart response templates for a review.
 * It caches template responses and then on click it cycles through them.
 */
const SmartResponseButton = (props) => {
  const [index, setIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [keyedTemplates, setKeyedTemplates] = useState([]);
  const [clicksCounter, setCountClicks] = useState(1);

  const [tooltipOpen, setTooltipOpen] = useState(false);
  const tooltipToggle = () => setTooltipOpen(!tooltipOpen);

  useEffect(() => {
    if (templates.length > 0) selectTemplate();
  }, [templates]);

  const handleSmartResponseClick = () => {
    setCountClicks(clicksCounter + 1)
    if (props.disabled) return undefined;
    if (templates.length === 0) {
      fetchSmartResponseTemplates();
    } else {
      selectTemplate();
    }
    props.smartResponseClicksCounter(clicksCounter)
  };

  const fetchSmartResponseTemplates = () => {
    recordEvent("smartResponseButtonClick", {value: "Initial_click", reviewId: props.review.reviewId});
    props.onStartLoad();
    setLoading(true);
    reviewsAPI.generateReviewResponseTemplates(props.review.reviewId).then(resp => {
      setKeyedTemplates(resp);
      setTemplates(Object.keys(resp))
      setLoading(false);
      props.onEndLoad();
    })
  };

  const selectTemplate = () => {
    const currentTemplateIndex = index % templates.length
    const template = templates[currentTemplateIndex];
    const templateId = keyedTemplates[template]
    props.onSmartResponseReady(template, currentTemplateIndex, templateId);
    setIndex(index + 1);
  }

  return <>
    <Button id={`smart-response-button-${props.review.reviewId}`} icon="fas fa-hexagon" color="white" className={`btn btn-outline-info ${props.disabled || loading  ? "disabled" : ""}`} onClick={handleSmartResponseClick}>Suggest</Button>
      <Tooltip
          placement="top"
          isOpen={tooltipOpen}
          target={`smart-response-button-${props.review.reviewId}`}
          toggle={tooltipToggle}
          style={{minWidth:400}}
      >
        <div className={"text-left text-nowrap"}>
          <span>Pulse Suggest will recommend the 3 best review responses.</span><br/>
          <span>It may take up to 20 seconds to load the first set of responses.</span><br/>
          <span>Subsequent responses will load within 5 seconds.</span><br/>
          <span>Click on Suggest icon to cycle through the 3 suggested responses.</span>
        </div>
      </Tooltip>
  </>;
};

SmartResponseButton.propTypes = {
  review: PropTypes.object,
  onStartLoad: PropTypes.func,
  onEndLoad: PropTypes.func,
  onSmartResponseReady: PropTypes.func,
  disabled: PropTypes.bool,
  smartResponseClicksCounter: PropTypes.func
};

export default SmartResponseButton;
